<div class="page-header"><h1 class="page-title">View History</h1></div>
<nz-tabset [nzTabPosition]="'top'" nzType="card" nzSize="small" [nzSelectedIndex]="selectedTabIndex" (nzSelectedIndexChange)="selectedTabIndex = $event">
	<nz-tab [nzTitle]="'Records viewed by this agent'" class="m-0">
		<div class="row mt-3" *ngIf="selectedTabIndex==0">
			<div class="col">
				<app-table
					[downloadHeading]="'Records viewed by agent ' + agent.username"
					[downloadName]="'records_viewed_by_agent_' + agent.username"
					[data]="resultsByAgent"
					[headerClass]="'table-info'"
					[columns]="columnRefByAgent"
					[loading]="loading"
					(onUpdateRequired)="doFetchResultsByAgent($event)">
					<ng-template #date let-row="row">
						<td>{{row.date | date: 'yyyy-MM-dd HH:mm:ss'}}</td>
					</ng-template>
					<ng-template #action let-row="row">
						<ng-container [ngSwitch]="row.recordType">
							<td *ngSwitchCase="'AgentEntity'">
								<a [routerLink]="['/agent','view',row.recordId]" class="btn btn-outline-secondary">View Agent</a>
							</td>
							<td *ngSwitchCase="'AgentApprovalEntity'">
								<a [routerLink]="['/agent','approval',row.recordId]" class="btn btn-outline-secondary">View Approval</a>
							</td>
							<td *ngSwitchCase="'PersonMsisdnEntity'">
								<a [routerLink]="['/subscriber','sim-view',row.recordIdSecondary,row.recordId]" class="btn btn-outline-secondary">View MSISDN</a>
							</td>
							<td *ngSwitchCase="'DocumentEntity'">
								<a [routerLink]="['/subscriber','document-view',row.recordId]" class="btn btn-outline-secondary">View Document</a>
							</td>
							<td *ngSwitchCase="'PersonEntity'">
								<a [routerLink]="['subscriber','view','audit','-',row.recordId]" class="btn btn-outline-secondary">View Subscriber</a>
							</td>
							<td *ngSwitchDefault>
								<small>Unhandled type: [{{row.recordType}}]</small>
							</td>
						</ng-container>
					</ng-template>
				</app-table>
			</div>
		</div>
	</nz-tab>
	<nz-tab [nzTitle]="'This agent viewed by other agents'" class="m-0">
		<div class="row mt-3" *ngIf="selectedTabIndex==1">
			<div class="col">
				<app-table
					[downloadHeading]="'Records viewed by agents'"
					[downloadName]="'records_viewed_by_agents'"
					[data]="resultsOfAgent"
					[headerClass]="'table-info'"
					[columns]="columnRefOfAgent"
					[loading]="loading"
					(onUpdateRequired)="doFetchResultsOfAgent($event)"
					>
					<ng-template #date let-row="row">
						<td>{{row.date | date: 'yyyy-MM-dd HH:mm:ss'}}</td>
					</ng-template>
				</app-table>
			</div>
		</div>
	</nz-tab>
</nz-tabset>
